import toast from "react-hot-toast";
import { from_YYYYMMDDHHMMSS } from "../config/dateFormatting";
import { ISeatingContent } from "../planEatApi/PlanEatFacade";

export function isSeatingVerified(seating: ISeatingContent){
    if(seating.officeId == ""){
        toast.error("Please select an office")
        return false
    } else if(seating.seatingName.length === 0){
        toast.error("Please enter at seating name of at least one character")
        return false
    } else if(seating.seatingCapacity <= 0){
        toast.error("Please select at seating capacity")
        return false
    }  else if(from_YYYYMMDDHHMMSS(seating.seatingStart) >= from_YYYYMMDDHHMMSS(seating.seatingEnd)){
        toast.error("The seating start shall be before the seating end")
        return false
    } else if(seating.priceModelId === ""){
        toast.error("Please select a Price Model")
        return false
    }else {
        return true
    }
}